<qbe-panel-component>
  <div [ngSwitch]="processConfirmState$ | async" class="page-container">
    <ng-container *ngSwitchCase="apiState.error">
      <app-error [showTryAgain]="true" (tryAgain)="fetchConfirm()"></app-error>
    </ng-container>
    <ng-container *ngSwitchCase="apiState.success">
      <ng-container [ngSwitch]="paymentsPolicyState$ | async">
        <ng-container *ngSwitchCase="apiState.error">
          <app-error [showTryAgain]="true" (tryAgain)="fetchPolicy()" [appError]="paymentsPolicyError$ | async"></app-error>
        </ng-container>
        <app-loader *ngSwitchDefault view="flex"></app-loader>
      </ng-container>
    </ng-container>
    <app-loader *ngSwitchDefault view="flex"></app-loader>
  </div>
</qbe-panel-component>

